
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as mh6Rr4C3smV1bw3mr_2I2rMY7FQIyKpJVaEb3LCEKNq4Meta } from "/nuxtWeb/pages/v/m.vue?macro=true";
import { default as indexs0dizR8Z1uJZRzbKRf4wJpfEab0mFix51iXhKJjApiEMeta } from "/nuxtWeb/pages/index.vue?macro=true";
import { default as indexkikXjWYVB6PqPRmDI4o3eIvrhjD0Os_lZcPPNojniPUMeta } from "/nuxtWeb/pages/v/index.vue?macro=true";
import { default as pcZ_EP__IMET6WcF9Y0WyeJdgG6ruwbQdoEy2_tZEcO28Meta } from "/nuxtWeb/pages/detail/pc.vue?macro=true";
import { default as logineNLAqPiBgAa0QntZGIP9F_45lR19Zu8XAYkIDjbXbzHFkMeta } from "/nuxtWeb/pages/sub/login.vue?macro=true";
import { default as index1T2Td6BzxmVVSiayunxRXT_456VhMZ8E4Wr552pcHFuPMMeta } from "/nuxtWeb/pages/cart/index.vue?macro=true";
import { default as indexRghymR98fKeSpRh4vH7flLqiNodPDPyOpqEDBXbA_45KYMeta } from "/nuxtWeb/pages/shop/index.vue?macro=true";
import { default as querykMJuTvwg9ft9VYyD6NjLfTtr_t8cfd7u8ISh1J5l6d0Meta } from "/nuxtWeb/pages/order/query.vue?macro=true";
import { default as webAZabJredTJt_vlKY3O32hc05T5Cdu3JUXalrcBnTuZYMeta } from "/nuxtWeb/pages/preview/web.vue?macro=true";
import { default as indexf4ew68tovwv_Hp4ndNcnjK3SEjXCed_GVJg002Xb1jEMeta } from "/nuxtWeb/pages/detail/index.vue?macro=true";
import { default as registerTQF_45SWs8i8ONica6ZN3S3RRPw18_45N7vQPSBAN5GGlewMeta } from "/nuxtWeb/pages/sub/register.vue?macro=true";
import { default as wacitivityu4blMZK4JHteI_FTABLGWf8Nj_kvnDoYmLv39uVOlVEMeta } from "/nuxtWeb/pages/v/wacitivity.vue?macro=true";
import { default as indexbrNDBuY6_45dwJA03pO8UX068_45M0sSHxI9cmE_459GjlAJAMeta } from "/nuxtWeb/pages/payment/index.vue?macro=true";
import { default as indexqR1iWf7s7bXIgm683mS_45zCyF0HvLSbKde6LLXF9DsHAMeta } from "/nuxtWeb/pages/preview/index.vue?macro=true";
import { default as indexyB1eGXy85Ygs_8WxnvYHj9GYw_S_45CfxC1a6ba2ahpiEMeta } from "/nuxtWeb/pages/product/index.vue?macro=true";
import { default as indexFv8PGAwXbq0QJ0n_45U5XBM6e6k8qHl7RQmf7_WryH4msMeta } from "/nuxtWeb/pages/service/index.vue?macro=true";
import { default as refindpswJMVqrlBc3dbJn2biA0VjHe1EqD1QTv8qKV2dw51SqlMMeta } from "/nuxtWeb/pages/sub/refindpsw.vue?macro=true";
import { default as index_lEfD9AHQ6muLV1PJA_45L9RiCJaHfmuCKxAZxosqC4dgMeta } from "/nuxtWeb/pages/category/index.vue?macro=true";
import { default as resultto1ReYGLme3wjpRuj_p6Y0_45kjyQN8bxx8_45n27e4dglwMeta } from "/nuxtWeb/pages/payment/result.vue?macro=true";
import { default as privacy_45policyoFoggrDLMRS8RPSGcOcIn_BWtsVT9KKDvfkltU9Zp1IMeta } from "/nuxtWeb/pages/privacy-policy.vue?macro=true";
import { default as _91slug_93Ccotolsn4qDS7MGWi3ZLwkCbUlNvMlggXk8aCDeyx6EMeta } from "/nuxtWeb/pages/product/[slug].vue?macro=true";
import { default as search2pjgIQ1llPYH9GFL9lXDYDQTBgw8vic_PTWN6JeeiwwMeta } from "/nuxtWeb/pages/product/search.vue?macro=true";
import { default as indexTA8fbUSQ4gEeEhTS_45yeINVq6K08rYRaWCopUnmZGK_45gMeta } from "/nuxtWeb/pages/sub/user/index.vue?macro=true";
import { default as user_45agreement6ar1XrTSnjMmEFnfd1OudLUMY91gcyzSNBtVW0DwZ10Meta } from "/nuxtWeb/pages/user-agreement.vue?macro=true";
import { default as cashier5C1j0WJmkddXJ3SeGHMYjVjROtZB37hBvEm4plEhMtMMeta } from "/nuxtWeb/pages/payment/cashier.vue?macro=true";
import { default as account_45deletionWMaCC_45sXIrzkMKGxu6vKCW3I_45QEQrXOY0JEZpzEW5rQMeta } from "/nuxtWeb/pages/account-deletion.vue?macro=true";
import { default as couponscNKZ1RwjKo_OB5DTLC0L4eIRLsL8svhK_czO5ifxyQsMeta } from "/nuxtWeb/pages/sub/user/coupons.vue?macro=true";
import { default as profile6Q02ddb0zH77GNqzUEEazYTXr5nXiuN13updVt0FNMsMeta } from "/nuxtWeb/pages/sub/user/profile.vue?macro=true";
import { default as PasswordLoginZL6kMpiHk5ulJwJQx43X79WokjmXv_45_45OuvGAGDrpsh8Meta } from "/nuxtWeb/pages/sub/PasswordLogin.vue?macro=true";
import { default as test_91_46_46_46path_93lS9vxJ1rPCY3xG70_45x2jqrH5lbOmJSeGfsAnN1D05PIMeta } from "/nuxtWeb/pages/sub/test[...path].vue?macro=true";
import { default as successful9554NbcGTADNBQVVLeZXACOJJ0UgOjyV4_45AsymiY958Meta } from "/nuxtWeb/pages/payment/successful.vue?macro=true";
import { default as index_32copyqCDeyvx_45qnTp_451TBwvJ6ck7PVPI8bRxvhLLv8lCBwGMMeta } from "/nuxtWeb/pages/product/index copy.vue?macro=true";
import { default as ShopSearchzFt5gT7bFw_nvz2kKuPhgACPJV5hGW5ndHXpf3klW7YMeta } from "/nuxtWeb/pages/product/ShopSearch.vue?macro=true";
import { default as cashieruu1dSQOOBnrnE9L_DaivAolXStpFpsJzNj5LpyBTGf0Meta } from "/nuxtWeb/pages/sub/payment/cashier.vue?macro=true";
import { default as orderdetailzAWPsITZN6MpDBD61g8SUjWWr2DL4UXB3I3PPZLgdzMMeta } from "/nuxtWeb/pages/sub/user/orderdetail.vue?macro=true";
import { default as member_45levelCpCIpGsyuRG_45aiQAKttl9Mz1j8hEdcsSG7hwEDwtUuEMeta } from "/nuxtWeb/pages/sub/user/member-level.vue?macro=true";
import { default as australia_45homeN13_DG743PfNFPpybqjq9KRS9WRWvhFNlIdVSNWt4PEMeta } from "/nuxtWeb/pages/preview/australia-home.vue?macro=true";
import { default as publicDetailM2DN6zX3kpIeahpWKiEbZ5_45h2lq0DssDjgUIUG7PUnIMeta } from "/nuxtWeb/pages/sub/order/publicDetail.vue?macro=true";
import { default as _91page_9332U8AIaVunVeShdOBN886rDqwctAQGIYxof0ETHQtHwMeta } from "/nuxtWeb/pages/preview/australia/[page].vue?macro=true";
import { default as _91_46_46_46slug_93m_45Q2GV5ZLuDOWocv0awpErREwMJZj_45Xwl_45lhsEw3iEwMeta } from "/nuxtWeb/pages/product/GoodsList/[...slug].vue?macro=true";
import { default as publicDetail_32copycFbnU32elKusqJ3Cun_457GGexXlOwh7wbZ2IvPiOMtnIMeta } from "/nuxtWeb/pages/sub/order/publicDetail copy.vue?macro=true";
import { default as _91_46_46_46slug_931Q5pY_ucuD23hCBbjimwOBED8Hom_SKMqOkYyDgRGZsMeta } from "/nuxtWeb/pages/product/CategoryList/[...slug].vue?macro=true";
export default [
  {
    name: "v-m",
    path: "/v/m",
    component: () => import("/nuxtWeb/pages/v/m.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/nuxtWeb/pages/index.vue")
  },
  {
    name: "v",
    path: "/v",
    component: () => import("/nuxtWeb/pages/v/index.vue")
  },
  {
    name: "detail-pc",
    path: "/detail/pc",
    component: () => import("/nuxtWeb/pages/detail/pc.vue")
  },
  {
    name: "sub-login",
    path: "/sub/login",
    meta: logineNLAqPiBgAa0QntZGIP9F_45lR19Zu8XAYkIDjbXbzHFkMeta || {},
    component: () => import("/nuxtWeb/pages/sub/login.vue")
  },
  {
    name: "cart",
    path: "/cart",
    meta: index1T2Td6BzxmVVSiayunxRXT_456VhMZ8E4Wr552pcHFuPMMeta || {},
    component: () => import("/nuxtWeb/pages/cart/index.vue")
  },
  {
    name: "shop",
    path: "/shop",
    component: () => import("/nuxtWeb/pages/shop/index.vue")
  },
  {
    name: "order-query",
    path: "/order/query",
    meta: querykMJuTvwg9ft9VYyD6NjLfTtr_t8cfd7u8ISh1J5l6d0Meta || {},
    component: () => import("/nuxtWeb/pages/order/query.vue")
  },
  {
    name: "preview-web",
    path: "/preview/web",
    component: () => import("/nuxtWeb/pages/preview/web.vue")
  },
  {
    name: "detail",
    path: "/detail",
    component: () => import("/nuxtWeb/pages/detail/index.vue")
  },
  {
    name: "sub-register",
    path: "/sub/register",
    meta: registerTQF_45SWs8i8ONica6ZN3S3RRPw18_45N7vQPSBAN5GGlewMeta || {},
    component: () => import("/nuxtWeb/pages/sub/register.vue")
  },
  {
    name: "v-wacitivity",
    path: "/v/wacitivity",
    component: () => import("/nuxtWeb/pages/v/wacitivity.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/nuxtWeb/pages/payment/index.vue")
  },
  {
    name: "preview",
    path: "/preview",
    component: () => import("/nuxtWeb/pages/preview/index.vue")
  },
  {
    name: "product",
    path: "/product",
    component: () => import("/nuxtWeb/pages/product/index.vue")
  },
  {
    name: "service",
    path: "/service",
    meta: indexFv8PGAwXbq0QJ0n_45U5XBM6e6k8qHl7RQmf7_WryH4msMeta || {},
    component: () => import("/nuxtWeb/pages/service/index.vue")
  },
  {
    name: "sub-refindpsw",
    path: "/sub/refindpsw",
    meta: refindpswJMVqrlBc3dbJn2biA0VjHe1EqD1QTv8qKV2dw51SqlMMeta || {},
    component: () => import("/nuxtWeb/pages/sub/refindpsw.vue")
  },
  {
    name: "category",
    path: "/category",
    meta: index_lEfD9AHQ6muLV1PJA_45L9RiCJaHfmuCKxAZxosqC4dgMeta || {},
    component: () => import("/nuxtWeb/pages/category/index.vue")
  },
  {
    name: "payment-result",
    path: "/payment/result",
    component: () => import("/nuxtWeb/pages/payment/result.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: privacy_45policyoFoggrDLMRS8RPSGcOcIn_BWtsVT9KKDvfkltU9Zp1IMeta || {},
    component: () => import("/nuxtWeb/pages/privacy-policy.vue")
  },
  {
    name: "product-slug",
    path: "/product/:slug()",
    component: () => import("/nuxtWeb/pages/product/[slug].vue")
  },
  {
    name: "product-search",
    path: "/product/search",
    component: () => import("/nuxtWeb/pages/product/search.vue")
  },
  {
    name: "sub-user",
    path: "/sub/user",
    meta: indexTA8fbUSQ4gEeEhTS_45yeINVq6K08rYRaWCopUnmZGK_45gMeta || {},
    component: () => import("/nuxtWeb/pages/sub/user/index.vue")
  },
  {
    name: "user-agreement",
    path: "/user-agreement",
    meta: user_45agreement6ar1XrTSnjMmEFnfd1OudLUMY91gcyzSNBtVW0DwZ10Meta || {},
    component: () => import("/nuxtWeb/pages/user-agreement.vue")
  },
  {
    name: "payment-cashier",
    path: "/payment/cashier",
    component: () => import("/nuxtWeb/pages/payment/cashier.vue")
  },
  {
    name: "account-deletion",
    path: "/account-deletion",
    meta: account_45deletionWMaCC_45sXIrzkMKGxu6vKCW3I_45QEQrXOY0JEZpzEW5rQMeta || {},
    component: () => import("/nuxtWeb/pages/account-deletion.vue")
  },
  {
    name: "sub-user-coupons",
    path: "/sub/user/coupons",
    meta: couponscNKZ1RwjKo_OB5DTLC0L4eIRLsL8svhK_czO5ifxyQsMeta || {},
    component: () => import("/nuxtWeb/pages/sub/user/coupons.vue")
  },
  {
    name: "sub-user-profile",
    path: "/sub/user/profile",
    meta: profile6Q02ddb0zH77GNqzUEEazYTXr5nXiuN13updVt0FNMsMeta || {},
    component: () => import("/nuxtWeb/pages/sub/user/profile.vue")
  },
  {
    name: "sub-PasswordLogin",
    path: "/sub/PasswordLogin",
    meta: PasswordLoginZL6kMpiHk5ulJwJQx43X79WokjmXv_45_45OuvGAGDrpsh8Meta || {},
    component: () => import("/nuxtWeb/pages/sub/PasswordLogin.vue")
  },
  {
    name: "sub-testpath",
    path: "/sub/test:path(.*)*",
    component: () => import("/nuxtWeb/pages/sub/test[...path].vue")
  },
  {
    name: "payment-successful",
    path: "/payment/successful",
    component: () => import("/nuxtWeb/pages/payment/successful.vue")
  },
  {
    name: "product-index copy",
    path: "/product/index%20copy",
    component: () => import("/nuxtWeb/pages/product/index copy.vue")
  },
  {
    name: "product-ShopSearch",
    path: "/product/ShopSearch",
    meta: ShopSearchzFt5gT7bFw_nvz2kKuPhgACPJV5hGW5ndHXpf3klW7YMeta || {},
    component: () => import("/nuxtWeb/pages/product/ShopSearch.vue")
  },
  {
    name: "sub-payment-cashier",
    path: "/sub/payment/cashier",
    component: () => import("/nuxtWeb/pages/sub/payment/cashier.vue")
  },
  {
    name: "sub-user-orderdetail",
    path: "/sub/user/orderdetail",
    meta: orderdetailzAWPsITZN6MpDBD61g8SUjWWr2DL4UXB3I3PPZLgdzMMeta || {},
    component: () => import("/nuxtWeb/pages/sub/user/orderdetail.vue")
  },
  {
    name: "sub-user-member-level",
    path: "/sub/user/member-level",
    meta: member_45levelCpCIpGsyuRG_45aiQAKttl9Mz1j8hEdcsSG7hwEDwtUuEMeta || {},
    component: () => import("/nuxtWeb/pages/sub/user/member-level.vue")
  },
  {
    name: "preview-australia-home",
    path: "/preview/australia-home",
    meta: australia_45homeN13_DG743PfNFPpybqjq9KRS9WRWvhFNlIdVSNWt4PEMeta || {},
    component: () => import("/nuxtWeb/pages/preview/australia-home.vue")
  },
  {
    name: "sub-order-publicDetail",
    path: "/sub/order/publicDetail",
    meta: publicDetailM2DN6zX3kpIeahpWKiEbZ5_45h2lq0DssDjgUIUG7PUnIMeta || {},
    component: () => import("/nuxtWeb/pages/sub/order/publicDetail.vue")
  },
  {
    name: "preview-australia-page",
    path: "/preview/australia/:page()",
    meta: _91page_9332U8AIaVunVeShdOBN886rDqwctAQGIYxof0ETHQtHwMeta || {},
    component: () => import("/nuxtWeb/pages/preview/australia/[page].vue")
  },
  {
    name: "product-GoodsList-slug",
    path: "/product/GoodsList/:slug(.*)*",
    component: () => import("/nuxtWeb/pages/product/GoodsList/[...slug].vue")
  },
  {
    name: "sub-order-publicDetail copy",
    path: "/sub/order/publicDetail%20copy",
    component: () => import("/nuxtWeb/pages/sub/order/publicDetail copy.vue")
  },
  {
    name: "product-CategoryList-slug",
    path: "/product/CategoryList/:slug(.*)*",
    component: () => import("/nuxtWeb/pages/product/CategoryList/[...slug].vue")
  }
]